import "array.prototype.flatmap";
import React, { useEffect, useState } from "react";

import { Wrapper, Row, Scroll } from "app/NativeComponents/common";
import { range } from "app/DealMachineCore/actions";

import CheckBoxes from "./CheckBoxes";
import ListColumn from "./ListColumn";
import Pagination from "./Pagination";
import HeaderRow from "./HeaderRow";

const GridList = props => {
  const [scroll_height, setScroll_height] = useState(0);
  const _scroll_view = React.createRef();
  const _header_scroll_view = React.createRef();

  const updateScrollPositions = offset => {
    _scroll_view.current.scrollLeft = offset;
    _header_scroll_view.current.scrollLeft = offset;
  };

  const calculateHeight = () => {
    if (props.device === "desktop") {
      const main_view_height = document.getElementById("deal-main-view")
        .offsetHeight;
      setScroll_height(main_view_height - 213);
    }
  };

  useEffect(() => {
    calculateHeight();
  }, [props.window_height, props.list_properties.length]);

  const renderColumns = (props, header_only = false) => {
    return props.list_settings.user_list_columns.flatMap((column, i) => {
      if (!column.show || column.main_column) return <Wrapper key={i} />;
      if (column.column_format != "single") {
        switch (column.slug) {
          default:
            break;
          case "phone_numbers":
            const max_phone_numbers = Math.max.apply(
              Math,
              props.list_properties.map(({ deal }) =>
                deal.removed != 1 && deal.phone_numbers
                  ? deal.phone_numbers.length
                  : 0
              )
            );
            const initialPhoneWidth = props.phone_column_widths.find(
              pcw => pcw.slug === "phone_number_0"
            );
            let phone_data_columns = max_phone_numbers
              ? []
              : [
                  {
                    slug: "phone_number_0",
                    format: "phone_numbers",
                    title: `Phone Numbers`,
                    index: -1,
                    width: initialPhoneWidth ? initialPhoneWidth.width : 150
                  }
                ];

            for (let j = 0; j < max_phone_numbers; j++) {
              const slug = `phone_number_${j + 1}`;
              const phoneColumnWidth = props.phone_column_widths.find(
                pcw => pcw.slug === slug
              );
              const width = phoneColumnWidth ? phoneColumnWidth.width : 150;
              phone_data_columns = [
                ...phone_data_columns,
                {
                  slug,
                  format: "phone_numbers",
                  title: `Phone ${j + 1}`,
                  index: j,
                  width
                }
              ];
            }

            return phone_data_columns.map(col => (
              <ListColumn
                key={col.slug}
                column_section={{
                  card_column: false,
                  deal: true,
                  show: true,
                  sort_by: false,
                  format: col.format,
                  slug: col.slug,
                  title: col.title,
                  column_format: "split",
                  column_format_index: col.index,
                  width: col.width
                }}
                clearAll={props.clearAll}
                pressProperty={props.pressProperty}
                header_only={header_only}
                {...props}
              />
            ));
        }
      }

      return (
        <ListColumn
          key={i}
          {...props}
          column_section={column}
          clearAll={props.clearAll}
          pressProperty={props.pressProperty}
          header_only={header_only}
        />
      );
    });
  };

  if (!props.list_settings) return <Wrapper />;
  if (
    !(
      props.list_properties.length > 0 ||
      props.list_settings.user_list_columns.length > 0
    )
  )
    return <Wrapper />;
  return (
    <Wrapper style={{ flex: 1, overflow: "hidden" }}>
      <HeaderRow
        {...props}
        renderColumns={renderColumns}
        _header_scroll_view={_header_scroll_view}
        updateScrollPositions={updateScrollPositions}
      />
      <Scroll
        style={{
          flex: 1,
          overflow: "auto",
          height: "100%"
        }}
      >
        <Row
          style={{
            justifyContent: "flex-start",
            alignItems: "flex-start",
            overflow: "hidden"
          }}
        >
          <CheckBoxes {...props} />

          {props.list_settings.user_list_columns.map((column, i) => {
            if (column.main_column) {
              return (
                <ListColumn
                  key={i}
                  {...props}
                  column_section={column}
                  clearAll={props.clearAll}
                  pressProperty={props.pressProperty}
                />
              );
            }
            return null;
          })}

          <Scroll
            scroll_ref={_scroll_view}
            horizontal
            onScroll={e => {
              updateScrollPositions(_scroll_view.current.scrollLeft);
            }}
          >
            <Row
              style={{
                justifyContent: "flex-start",
                alignItems: "flex-start"
              }}
            >
              {renderColumns(props)}
            </Row>
          </Scroll>
        </Row>
      </Scroll>
      {/*


      <Scroll
        style={{
        flex: 1,
          backgroundColor: props.colors.card_color
        }}
      >
        <Row
          style={{
            justifyContent: "flex-start",
            alignItems: "flex-start",
            overflow: "hidden"
          }}
        >
          <CheckBoxes {...props} />

          {props.list_settings.user_list_columns.map((column, i) => {
            if (column.main_column) {
              return (
                <ListColumn
                  key={i}
                  {...props}
                  column_section={column}
                  clearAll={props.clearAll}
                  pressProperty={props.pressProperty}
                />
              );
            }
            return <Wrapper key={i} />;
          })}

          <Scroll horizontal>
            <Row
              style={{
                justifyContent: "flex-start",
                alignItems: "flex-start"
              }}
            >
              {renderColumns(props)}
            </Row>
          </Scroll>
        </Row>
      </Scroll>
      */}
      <Pagination clearAll={props.clearAll} {...props} />
    </Wrapper>
  );
};

export default GridList;
